import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Pair } from 'client/voladeum/pairs/types';
import { SLICE } from 'ducks/slice';

import { EMPTY_ARRAY } from '../../constants';

const initialState: Pair[] = EMPTY_ARRAY;

export const pairsSlice = createSlice({
  name: SLICE.PAIRS,
  initialState,
  reducers: {
    setPairs: (_state, action: PayloadAction<Pair[]>) => {
      return action.payload;
    },
    clearPairs: () => {
      return initialState;
    },
  },
});

export const { setPairs, clearPairs } = pairsSlice.actions;

export default pairsSlice.reducer;
